// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.spinner-container {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100vh; /* Pastikan spinner berada di tengah layar */
    background-color: rgba(255, 255, 255, 0.9); /* Background semi-transparan */
  }
  
  .spinner {
    width: 50px;
    height: 50px;
    border: 5px solid transparent; /* Lingkaran transparan */
    border-top: 5px solid red; /* Bagian yang terlihat */
    border-right: 5px solid blue; /* Kombinasi warna merah dan biru */
    border-radius: 50%;
    animation: spin 1.5s linear infinite;
  }
  
  /* Animasi rotasi */
  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
  `, "",{"version":3,"sources":["webpack://./src/style/LoadingSpinner.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,aAAa,EAAE,4CAA4C;IAC3D,0CAA0C,EAAE,+BAA+B;EAC7E;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,6BAA6B,EAAE,yBAAyB;IACxD,yBAAyB,EAAE,yBAAyB;IACpD,4BAA4B,EAAE,mCAAmC;IACjE,kBAAkB;IAClB,oCAAoC;EACtC;;EAEA,mBAAmB;EACnB;IACE;MACE,uBAAuB;IACzB;IACA;MACE,yBAAyB;IAC3B;EACF","sourcesContent":[".spinner-container {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    height: 100vh; /* Pastikan spinner berada di tengah layar */\n    background-color: rgba(255, 255, 255, 0.9); /* Background semi-transparan */\n  }\n  \n  .spinner {\n    width: 50px;\n    height: 50px;\n    border: 5px solid transparent; /* Lingkaran transparan */\n    border-top: 5px solid red; /* Bagian yang terlihat */\n    border-right: 5px solid blue; /* Kombinasi warna merah dan biru */\n    border-radius: 50%;\n    animation: spin 1.5s linear infinite;\n  }\n  \n  /* Animasi rotasi */\n  @keyframes spin {\n    0% {\n      transform: rotate(0deg);\n    }\n    100% {\n      transform: rotate(360deg);\n    }\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
